import { useEffect, useRef, useState } from 'react';
import { AppEnvironment } from './app/AppEnvironment';
import { AppEnvironmentContext, useAppState } from './app/context';
import { RootView } from './views/RootView';
import { SignIn } from './views/SignIn';

/** Gates the top-level UI on the auth phase (mirror of the Swift `FactoryApp`
 * scene switch): `booting` → spinner, `signedOut` → SignIn, `signedIn` →
 * RootView. Mock is always `signedIn`, so it renders RootView immediately. */
function Gate() {
  const state = useAppState();
  if (state.authPhase === 'booting') return <div className="spinner" />;
  if (state.authPhase === 'signedOut') return <SignIn />;
  return <RootView />;
}

/** App root: builds the AppEnvironment for the selected backend (Mock by
 * default), bootstraps it (resume/sign-in → refresh → start polling), and
 * provides it to the tree. Mirrors the Swift `FactoryApp` scene + bootstrap. */
export default function App() {
  // Build once. AppEnvironment.resolved() reads the go-live switch.
  const [env] = useState(() => AppEnvironment.resolved());
  const booted = useRef(false);

  useEffect(() => {
    if (booted.current) return;
    booted.current = true;
    void env.bootstrap();
    return () => env.stopLiveUpdates();
  }, [env]);

  return (
    <AppEnvironmentContext.Provider value={env}>
      <Gate />
    </AppEnvironmentContext.Provider>
  );
}
